import { element, elements } from '@shared/easyfy.core';
import { IFilterElementState, FilterStateType } from '@clientShared/filter.types';

export class FilterStateHelper {
  private elementsStates: IFilterElementState[];

  constructor() {
    this.elementsStates = [];
  }

  saveFilterState = () => {
    const saveElementsState = elements('[data-save-state]');
    if (saveElementsState && saveElementsState.length > 0) {
      this.elementsStates = [];
      const tempStates: IFilterElementState[] = [];
      saveElementsState.forEach((element: HTMLElement) => {
        const elementState = this.resolveStateAndValue(element);
        if (elementState) {
          tempStates.push(elementState);
        }
      });

      //arrange states so opens occur before scrolls.
      tempStates.forEach((state) => {
        if (state.stateType != FilterStateType.Scroll) this.elementsStates.push(state);
      });
      tempStates.forEach((state) => {
        if (state.stateType == FilterStateType.Scroll) this.elementsStates.push(state);
      });
    }
  };

  setFilterState = () => {
    if (!this.elementsStates) return;
    this.elementsStates.forEach((elementState) => {
      const domelement = element('#' + elementState.elementId) as HTMLElement;
      if (!domelement) return;
      switch (elementState.stateType) {
        case FilterStateType.Open: {
          if (domelement.nodeName.toLocaleLowerCase() == 'details' && elementState.value) domelement.setAttribute('open', 'true');
          break;
        }
        case FilterStateType.Scroll: {
          elementState.stateType = FilterStateType.Scroll;
          domelement.scrollTop = elementState.value;
          break;
        }
      }
    });
  };

  //#region Private Methods
  private resolveStateAndValue = (element: HTMLElement): IFilterElementState => {
    const elementState = {} as IFilterElementState;
    if (!element.id) return null;

    elementState.elementId = element.id;
    const stateType: FilterStateType = FilterStateType[element.getAttribute('data-save-state')];
    const elementType = element.nodeName.toLowerCase();

    switch (stateType) {
      case FilterStateType.Open: {
        elementState.stateType = FilterStateType.Open;
        if (elementType == 'details') {
          elementState.value = element.hasAttribute('open');
        }
        break;
      }
      case FilterStateType.Scroll: {
        elementState.stateType = FilterStateType.Scroll;
        elementState.value = element.scrollTop;
        break;
      }
    }
    return elementState;
  };
  //#endregion
}
